require('./ChannelDescription.scss');

const b = require('app/www/libs/b')('channel-description');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Link = require('app/www/components/blocks/Link/Link');

class ChannelDescription extends React.PureComponent {

    render() {
        const {i18n, text, siteUrl} = this.props;

        const linkProps = {
            attrs: {
                target: '_blank',
            },
            url: siteUrl,
        };

        let textHtml;

        if (text) {
            textHtml = text.split(/\n\n/g).map((p, i) => {
                const section = p.replace(/\n/g, '<br />');

                return <p key={i} className={b('paragraph')} dangerouslySetInnerHTML={{__html: section}} />;
            });
        }

        return (
            <div className={b()}>
                {textHtml && <div className={b('text')}>{textHtml}</div>}
                {siteUrl && (
                    <Link className={b('site')} {...linkProps}>
                        {i18n.get('channel-description.site')}
                    </Link>
                )}
            </div>
        );
    }
}

ChannelDescription.propTypes = {
    text: PropTypes.string,
    siteUrl: PropTypes.string,
};

module.exports = withI18n(ChannelDescription);
